import {title as fieldTitle} from './custom/title'
import {slug as fieldSlug} from './types/slug'
import {string as fieldString} from './types/string'
import type {FieldReturn, FieldDefaults} from '../types'

const F = {
  title: fieldTitle,
  slug: fieldSlug,
  string: fieldString,
}

// TODO: Make this configurable
export const fieldDefaults = ({
  fieldset,
  title = {},
  slug = {},
  path = {},
}: FieldDefaults = {}): FieldReturn[] => [
  F.title({fieldset, group: 'content', ...title}),
  F.slug({fieldset, group: 'meta', ...slug}),
  F.string({
    name: 'path',
    fieldset,
    readOnly: true,
    group: 'meta',
    ...path,
  }),
]
